import React, { Component } from "react";
import { Route, withRouter } from "react-router-dom";
import Tab from "../../../../Util/Tabs/Tab.js";
import Admin from "./Admins/Admins.js";
import User from "./User/User.js";
import "./Users.css";
import { Redirect } from 'react-router';
import { motion } from 'framer-motion';
import { pageTransitions, transitionDuration } from '../../../../Util/PageTransitions';
class Users extends Component {
  constructor() {
    super();
    this.state = {
      redirectLogin: false
    }
  }

  componentDidMount() { 
    if(!localStorage.getItem('token')){
      this.setState({redirectLogin : true})
    }
  }

  tabs = [
    {
      name: 'Users',
      url: ''
    },
    {
      name: 'Admins',
      url: '/admins'
    },
    // {
    //   name: 'Employees',
    //   url: '/employees'
    // }
  ];

  selectedTab = 0;

  setTab(event) {
  }

  render() {
    const redirect = this.state.redirectLogin;
    if (redirect) {
      return <Redirect to='/login'/>;
    }
    return (
      <>
      <motion.div className='outer-wrapper' initial={pageTransitions.initial} animate={pageTransitions.in} exit={pageTransitions.out} transition={{ duration: transitionDuration }}>
        <div className="content-wrapper users-wrapper">
          <div className="heading-wrapper">
            <h1 className="heading">{this.props.location.pathname === '/admin/users' ? 'Users' : this.props.location.pathname === '/admin/users/employees' ? 'Employees' : 'Admins'}</h1>
          </div>
          <Tab tabs={this.tabs} type="user_module"/>
          <Route path={`${this.props.match.path}`} exact>
            <User />
          </Route>
          <Route path={`${this.props.match.path}/admins`}>
            <Admin />
          </Route>
        </div>
      </motion.div>
      </>
    );
  }
}

export default withRouter(Users);
